// extracted by mini-css-extract-plugin
export default {"container":"Sizes_container__lNeVc","containerForm":"Sizes_containerForm__GUyZ9"};